import React from "react";
import ReactDOM from "react-dom/client"; // Cambiado para React 18+
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
